module.exports = __webpack_public_path__ + "static/assets/b8d7493c218d0b0eb5825f01b6501955.svg";